import React from "react";
import PropTypes from "prop-types";
import { shortMonthDate } from "utils/dateHelpers"

const HistoricalAccessToolActionFilters = ({ action }) => {
  const submissionTime = (startDate, endDate) => {
    if (startDate === null && endDate === null) return "No filter (all submissions)"
    if (startDate === null && endDate !== null) return `Submissions received on or before ${shortMonthDate(endDate, false)}`
    if (startDate !== null && endDate === null) return `Submissions received on or after ${shortMonthDate(startDate, false)}`
    return `Submissions received between ${shortMonthDate(startDate, false)} and ${shortMonthDate(endDate, false)}`
  }

  return (
    <section className="pl-4">
      <div className="pl-4">
        <div className="mb-2">
          <b>Selected Forms: </b>
          <ul className="mt-0">
            {action.forms.map((form) => (
              <li key={form.id}>
                {form.title} (count: {action.result.form_submissions[form.id]?.length || 0})
              </li>
            ))}
          </ul>
        </div>
        { action.taskForms.length > 0
          && (
            <div className="mb-2">
              <b>Selected Task Forms: </b>
              <ul className="mt-0">
                {action.taskForms.map((form) => (
                  <li key={form.id}>{form.title}</li>
                ))}
              </ul>
            </div>
          )}
        <div className="mb-2">
          <b>Submission Time: </b> {submissionTime(action.earliestSubmissionDate, action.latestSubmissionDate)}
        </div>
        {action.reportableFieldFilters.filter((field) => field.facilities.length > 0).map((field) => (
          <div className="mt-0" key={field.reportableField.id}>
            <b> {field.reportableField.name}:</b>
            <ul className="mt-0">
              {field.facilities.map((facility) => (
                <li className="screenreader-whitespace" key={facility.id}>
                  <span>{facility.name}</span>
                  {facility.departments.length > 0
                  && <span>: {facility.departments.map((department) => department.name).join(", ")}</span>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  )
}

HistoricalAccessToolActionFilters.propTypes = {
  action: PropTypes.object.isRequired,
}

export default HistoricalAccessToolActionFilters;
